// extracted by mini-css-extract-plugin
export var disabled = "_32-3";
export var growableInput = "_32-0";
export var tagContainer = "_32-2";
export var textInput = "_32-1";